module.exports = __webpack_public_path__ + "img/icons-complaint_white.ec9b01d5.svg";